var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Master',[_c('main',{staticClass:"content"},[_c('Header_Large',{staticClass:"text-center w-100 mb-2"},[_vm._v(_vm._s(_vm.headerText))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }